import React from 'react';
import { useMap } from 'react-leaflet';
import { MAP_CONFIG } from '../config';

// Dezente Nachricht, die angezeigt wird, wenn der Zoom-Level zu hoch ist
const ZoomLevelMessage: React.FC = () => {
  const map = useMap();
  const [isVisible, setIsVisible] = React.useState(false);

  React.useEffect(() => {
    const updateZoom = () => {
      const currentZoom = map.getZoom();
      setIsVisible(currentZoom < MAP_CONFIG.MIN_TREE_ZOOM_LEVEL);
    };

    // Initial update
    updateZoom();

    // Listen for zoom changes
    map.on('zoomend', updateZoom);

    return () => {
      map.off('zoomend', updateZoom);
    };
  }, [map]);

  if (!isVisible) {
    return null;
  }

  return (
    <div style={{
      position: 'absolute',
      bottom: '20px',
      left: '50%',
      transform: 'translateX(-50%)',
      background: 'rgba(0, 0, 0, 0.6)',
      color: 'white',
      padding: '8px 16px',
      borderRadius: '20px',
      fontSize: '13px',
      zIndex: 1000,
      pointerEvents: 'none',
      whiteSpace: 'nowrap',
      boxShadow: '0 2px 8px rgba(0, 0, 0, 0.3)'
    }}>
      Weiter hineinzoomen, um Bäume zu bearbeiten
    </div>
  );
};

export default ZoomLevelMessage;

